import { Outlet } from 'react-router-dom';
// For the development purpose, already imported in the WP theme.
// import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

export const GutentagLayout = (props) => {
    return (
        <>
            {
                (props.children === undefined) ? <Outlet/> : props.children
            }
        </>
    );
}
